import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { DsButton } from '@frontend/ui/button';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsCheckbox } from '@frontend/ui/checkbox';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { BetBuilderOverlayHeaderComponent } from 'packages/sports/web/app/src/event-details/bet-builder-v2/bet-builder-overlay-header/bet-builder-overlay-header.component';
import { MarketSubtypeLogoComponent } from 'packages/sports/web/app/src/marketsubtype-logo/marketsubtype-logo.component';
import { PriceboostCountSignpostComponent } from 'packages/sports/web/app/src/shared-priceboost/Components/priceboost-count-signpost.component';

import BetslipBaseModule from '../../base/betslip-base.module';
import { NavigateBetslipDirective } from '../quick-bet/directives/navigate-betslip.directive';
import BetbuilderInfoMessageComponent from '../single-bet/components/betbuilder-info-message.component';
import { BetbuilderPickUIComponent } from '../single-bet/components/betbuilder-pick-ui.component';
import { BetslipBetbuilderEditPickButtonComponent } from '../single-bet/components/betslip-betbuilder-edit-pick-button.component';
import { BetslipBetBuilderPickComponent } from '../single-bet/components/betslip-betbuilder-pick.component';
import { BetslipBetbuilderSelectionErrorComponent } from '../single-bet/components/betslip-betbuilder-selection-error.component';
import { BetslipBetbuilderSelectionComponent } from '../single-bet/components/betslip-betbuilder-selection.component';
import { BetslipGroupPickComponent } from '../single-bet/components/betslip-group-pick.component';
import { BetslipDigitalDialogFullService } from '../validation/services/dialogs/digital/betslip-digital-dialog-full.service';
import BetslipPickActions from './actions';
import BetslipPicksModule from './betslip-picks.module';
import { EachwayLinearPriceButtonComponent } from './components/digital/eachway-price-button-linear.component';
import { EachwayPriceButtonComponent } from './components/digital/eachway-price-button.component';
import { LineSwitcherButtonComponent } from './components/digital/line-switcher-button.component';
import OverAskBetPickComponent from './components/digital/overask-bet-pick.component';
import PickComboPreventionIconComponent from './components/digital/pick-combo-prevention-icon.component';
import PickComboPreventionIndicatorComponent from './components/digital/pick-combo-prevention-indicator.component';
import PickDisplayTemplatesComponent from './components/digital/pick-display-templates.component';
import PickListComponent from './components/digital/pick-list.component';
import { PickRemoveButtonComponent } from './components/digital/pick-remove-button/pick-remove-button.component';
import PickSelectionComponent from './components/digital/pick-selection.component';
import PicksToolbarLinearComponent from './components/digital/picks-toolbar-linear.component';
import PicksToolbarComponent from './components/digital/picks-toolbar.component';
import { StartingPriceButtonComponent } from './components/digital/starting-price-button.component';
import PickDigitalEffects from './effects/pick-digital-effects';
import PicksRefreshEffect from './effects/picks-refresh-effect';
import PickOddsModule from './pick-odds.module';
import PickTypeSelectorService from './services/pick-type-selector.service';

@NgModule({
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipPicksModule,
        EffectsModule.forFeature([PickDigitalEffects, PicksRefreshEffect]),
        NgxPopperjsModule,
        AutomationModule,
        PickOddsModule,
        PriceboostCountSignpostComponent,
        BetBuilderOverlayHeaderComponent,
        ShowInEpcotDirective,
        MarketSubtypeLogoComponent,
        DsButton,
        DsButtonIcon,
        DsCheckbox,
        IconCustomComponent,
        SportsThemedButtonDirective,
        NavigateBetslipDirective,
    ],
    providers: [BetslipDigitalDialogFullService, PickTypeSelectorService],
    declarations: [
        PickListComponent,
        OverAskBetPickComponent,
        PickDisplayTemplatesComponent,
        PickSelectionComponent,
        PicksToolbarComponent,
        EachwayPriceButtonComponent,
        StartingPriceButtonComponent,
        LineSwitcherButtonComponent,
        PickRemoveButtonComponent,
        BetslipBetBuilderPickComponent,
        BetslipBetbuilderSelectionComponent,
        BetslipBetbuilderSelectionErrorComponent,
        BetslipBetbuilderEditPickButtonComponent,
        BetbuilderInfoMessageComponent,
        BetbuilderPickUIComponent,
        BetbuilderInfoMessageComponent,
        BetslipGroupPickComponent,
        PickComboPreventionIndicatorComponent,
        PickComboPreventionIconComponent,
        PicksToolbarLinearComponent,
        EachwayLinearPriceButtonComponent,
    ],
    exports: [
        PickListComponent,
        PickSelectionComponent,
        PickComboPreventionIndicatorComponent,
        PicksToolbarComponent,
        OverAskBetPickComponent,
        EachwayPriceButtonComponent,
        StartingPriceButtonComponent,
        LineSwitcherButtonComponent,
        PickRemoveButtonComponent,
        PicksToolbarLinearComponent,
        EachwayLinearPriceButtonComponent,
        BetslipBetbuilderEditPickButtonComponent,
        BetbuilderInfoMessageComponent,
    ],
})
export default class BetslipDigitalPicksModule {
    static readonly BetslipPickActions = BetslipPickActions;
}
